/**
 * It represents UserConnection collection.
 */
import Backbone from 'backbone';

import PendingConnection from 'models/connections/PendingConnection';

var PendingConnections = Backbone.Collection.extend({
    model: PendingConnection,

    backend: 'gcapi',

    url: '/userprofile-service/connection/pending?mutualConnectionCountIncluded=true'
});

export default PendingConnections;
